var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditPencil = function SvgEditPencil(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit-pencil_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M13.333 9.333c0 1.867 0 2.8-.363 3.514a3.333 3.333 0 0 1-1.457 1.456c-.713.364-1.646.364-3.513.364H6.667c-1.867 0-2.8 0-3.514-.364a3.333 3.333 0 0 1-1.456-1.456c-.364-.713-.364-1.647-.364-3.514V8c0-1.867 0-2.8.364-3.513.32-.627.83-1.137 1.456-1.457.713-.363 1.647-.363 3.514-.363M5.374 9c.006-.234.009-.35.037-.46a.993.993 0 0 1 .118-.276c.06-.097.142-.18.307-.345l6.264-6.3a.973.973 0 0 1 1.218-.13c.458.295.85.684 1.15 1.14.016.027.033.052.05.078.25.404.168.914-.16 1.244l-6.216 6.25c-.17.172-.256.258-.356.32a.985.985 0 0 1-.285.118c-.114.027-.235.027-.476.027l-1.692-.003L5.374 9Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit-pencil_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditPencil);
export default ForwardRef;